var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons / tabbar / 01-sac inactif"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89134 7.03866C4.89771 3.15664 7.88191 0 11.5487 0C15.2155 0 18.1997 3.15664 18.206 7.03866H20.8765C21.3117 7.03866 21.6737 7.39377 21.7062 7.85286L23.0834 27.0641C23.1042 27.1408 23.115 27.2219 23.115 27.3047C23.115 27.792 22.7422 28.1867 22.2829 28.1867H22.2662H0.83204C0.600697 28.1867 0.37934 28.0845 0.22206 27.9048C0.0647798 27.725 -0.0151084 27.4836 0.00236712 27.2395L1.39126 7.85374C1.42371 7.39377 1.78571 7.03866 2.22093 7.03866H4.89134ZM4.89132 8.80087V10.5635C4.89132 11.0499 5.26414 11.4446 5.72349 11.4446C6.18285 11.4446 6.55566 11.0499 6.55566 10.5635V8.80087H16.5417V10.5635C16.5417 11.0499 16.9145 11.4446 17.3739 11.4446C17.8332 11.4446 18.206 11.0499 18.206 10.5635V8.80087H20.1051L21.3683 26.4243H1.7291L2.99234 8.80087H4.89132ZM16.5417 7.03866H6.55568C6.56205 4.1277 8.79896 1.76234 11.5487 1.76234C14.2984 1.76234 16.5353 4.1277 16.5417 7.03866Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_287_1433",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92225 6.36738C5.24796 2.79921 8.09561 0 11.5486 0C15.0015 0 17.8491 2.79921 18.1749 6.36738H21.2388C21.674 6.36738 22.036 6.72249 22.0685 7.18158L23.4457 26.3929C23.4665 26.4695 23.4773 26.5506 23.4773 26.6334C23.4773 27.1207 23.1045 27.5155 22.6452 27.5155H22.6285H1.19434C0.963002 27.5155 0.741645 27.4132 0.584365 27.2335C0.427085 27.0537 0.347196 26.8123 0.364672 26.5682L1.75356 7.18246C1.78602 6.72249 2.14801 6.36738 2.58324 6.36738H4.92225ZM4.8912 8.12959V10.5635C4.8912 11.0499 5.26401 11.4446 5.72337 11.4446C6.18273 11.4446 6.55554 11.0499 6.55554 10.5635V8.12959H16.5416V10.5635C16.5416 11.0499 16.9144 11.4446 17.3737 11.4446C17.8331 11.4446 18.2059 11.0499 18.2059 10.5635V8.12959H20.4674L21.7306 25.753H2.0914L3.35463 8.12959H4.8912ZM16.5001 6.36738H6.59705C6.9145 3.77261 9.01361 1.76234 11.5486 1.76234C14.0835 1.76234 16.1826 3.77261 16.5001 6.36738Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_287_1433)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.c0a832d7e60e71b477e5b07fbc7ca94b.svg";
export { ForwardRef as ReactComponent };